/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Wizard_Abilities_LimitInputs */



/**
* | output |
* | --- |
* | "Only the abilities I pick" |
*
* @param {Agent_Wizard_Abilities_LimitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_abilities_limit = /** @type {((inputs?: Agent_Wizard_Abilities_LimitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_Abilities_LimitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur die Fähigkeiten, die ich auswähle")
	return /** @type {LocalizedString} */ ("Only the abilities I pick")
});